import { updateQueryParam } from '@repo/shared/shared';
import { useTranslation } from 'next-i18next';
import { useSearchParams } from 'next/navigation';
import { useRouter } from 'next/router';
import { OptionSelector } from '@/shared/ui/OptionSelector';
import { prepareColor } from '../../lib/colorUtils';
import ColorOptionCard, { ColorOption } from './ColorOptionCard';

interface ColorSelectorProps {
  colors: ColorOption[];
}

const renderColorOption = (option: ColorOption, isSelected: boolean) => {
  return (
    <ColorOptionCard
      isSelected={isSelected}
      option={option}
    />
  );
};

const ColorSelector = ({ colors }: ColorSelectorProps) => {
  const { t } = useTranslation();
  const router = useRouter();
  const searchParams = useSearchParams();

  const color = prepareColor(searchParams?.get('color'));

  const onChange = (newColor: string) => {
    updateQueryParam(router, 'color', newColor);
  };

  // Translate color labels
  const translatedColors = colors.map((colorOption) => ({
    ...colorOption,
    label: t(colorOption.label),
  }));

  return (
    <OptionSelector
      direction='horizontal'
      optionContainerProps={{ boxSize: '5rem' }}
      optionWidth='auto'
      options={translatedColors}
      renderOption={renderColorOption}
      title={t('store.product.color')}
      value={color}
      onChange={onChange}
    />
  );
};

export default ColorSelector;
